import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Clock, AlertTriangle, Coins, Zap } from 'lucide-react';

const problems = [
  {
    icon: <TrendingUp size={24} />,
    title: "Rising Ticket Volume",
    description: "As enterprises scale, ticket volume grows exponentially, overwhelming human teams and leading to critical response delays."
  },
  {
    icon: <Clock size={24} />,
    title: "Manual Triage Delays",
    description: "Hours are lost in manual ticket classification, prioritization, and routing, causing bottlenecks at the very first touchpoint."
  },
  {
    icon: <Zap size={24} />,
    title: "Repetitive L1/L2 Tasks",
    description: "Highly skilled engineers spend over 40% of their time on mundane, repetitive issues that could be resolved autonomously."
  },
  {
    icon: <AlertTriangle size={24} />,
    title: "SLA Breaches",
    description: "Inconsistent manual processes lead to missed deadlines and SLA violations, impacting business continuity and user trust."
  },
  {
    icon: <Coins size={24} />,
    title: "High Operational Cost",
    description: "Scaling support via human headcount is linear and unsustainable for modern enterprise budgets and speed requirements."
  }
];

const Problem = () => {
  return (
    <section id="solutions" className="problem-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="title">The IT Support Bottleneck</h2>
          <p className="subtitle">Legacy IT operations are struggling to keep pace with the speed of digital business.</p>
        </div>

        <div className="problem-grid">
          {problems.map((item, index) => (
            <motion.div
              key={index}
              className="problem-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="problem-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Problem;
